//Mobile Header
const mobileHeaderBtns = document.querySelectorAll(
  '[data-mobile-nav-btn]'
);
const mobileHeader = document.querySelector('#mobileHeader');
const childLinkContainers = document.querySelectorAll(
  '.mobile-navigation__child-links-container'
);

mobileHeaderBtns.forEach(btn => {
  btn.addEventListener('click', () => {
    if (mobileHeader) {
      mobileHeader.classList.toggle('open');
      document
        .querySelector('body')
        .classList.toggle('overflow-hidden');
    }
    navigationInner.classList.add('active');
    setTimeout(() => {
      childLinkContainers.forEach(el => {
        el.classList.remove('active');
      });
    }, 300);
  });
});

/* Mobile Navigation */
const navigationInner = document.querySelector(
  '.mobile-navigation-inner'
);
const mobileNavBtns = document.querySelectorAll(
  '.mobile-navigation__link-container'
);

mobileNavBtns.forEach(btn => {
  btn.addEventListener('click', e => {
    const link = e.currentTarget.dataset.link;
    const childLinks = document.querySelector(
      `.mobile-navigation__child-links-container[data-link="${link}"]`
    );
    childLinks.classList.add('active');
    navigationInner.classList.remove('active');
  });
});

/* EnterView  */
const reveals = document.querySelectorAll('.reveal');
const stagger = document.querySelectorAll('.stagger');

if (reveals.length > 0) {
  enterView({
    selector: '.reveal',
    enter: (el, i) => {
      el.classList.add('entered');
    },
    exit: el => {
      el.classList.remove('entered');
    },
    offset: 0.1
  });
}

if (stagger.length > 0) {
  stagger.forEach(el => {
    el.querySelectorAll('.stagger-child').forEach((e, i) => {
      e.style.setProperty('--animation-order', i);
    });
  });
}

// SWIPER
const swiperProduct = new Swiper('#swiper-product', {
  direction: 'horizontal',
  slidesPerView: 1,
  pagination: {
    el: '.swiper-pagination',
    clickable: true
  }
});

const swiperArticleFeaturedProducts = new Swiper(
  '#swiper-article-featured-products',
  {
    direction: 'horizontal',
    slidesPerView: 1,
    navigation: {
      nextEl: '.swiper-article-featured-products-button-next',
      prevEl: '.swiper-article-featured-products-button-prev'
    }
  }
);

const swiperFeaturedCollection = new Swiper(
  '#swiper-featured-collection',
  {
    slidesPerView: 1.2,
    spaceBetween: 16,
    slidesOffsetBefore: 16,
    slidesOffsetAfter: 16,
    loop: true,
    allowTouchMove: true,
    autoplay: false,
    navigation: {
      nextEl: '.swiper-featured-collection-button-next',
      prevEl: '.swiper-featured-collection-button-prev'
    },
    breakpoints: {
      768: {
        slidesPerView: 4,
        spaceBetween: 60,
        centeredSlides: true
      }
    }
  }
);

// Stores carousel
const swiperStoresWrapper = document.querySelector('#swiper-stores');

if (swiperStoresWrapper) {
  const swiperStores = new Swiper('#swiper-stores', {
    loop: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false
    },
    speed: 800,
    slidesPerView: 1,
    effect: 'fade',
    fadeEffect: { crossFade: true },
    on: {
      init: function () {
        // Delay starting progress bar until the first frame after render
        requestAnimationFrame(() => {
          resetProgressBars();
          startProgressBar(this.realIndex);
        });
      },
      slideChange: function () {
        resetProgressBars();
        startProgressBar(this.realIndex);
      }
    }
  });

  function startProgressBar(index) {
    const locations = document.querySelectorAll('.stores__location');
    if (!locations.length) return;
    const bar = locations[index].querySelector('.progress-bar');
    locations.forEach(loc => loc.classList.remove('active'));
    locations[index].classList.add('active');

    // Reset before animating
    bar.style.transition = 'none';
    bar.style.width = '0%';
    void bar.offsetWidth;
    const totalTime =
      (swiperStores.params.autoplay.delay +
        swiperStores.params.speed) /
      1000;
    bar.style.transition = `width ${totalTime}s linear`;
    bar.style.width = '100%';
  }

  function resetProgressBars() {
    document.querySelectorAll('.progress-bar').forEach(bar => {
      bar.style.transition = 'none';
      bar.style.width = '0%';
    });
  }
  document.querySelectorAll('.stores__location').forEach((loc, i) => {
    loc.addEventListener('click', e => {
      e.preventDefault();
      swiperStores.slideToLoop(i);
    });
  });
}
// End of stores carousel

const swiperStepContent = new Swiper('#swiper-step-content', {
  direction: 'horizontal',
  slidesPerView: 1.1,
  breakpoints: {
    768: {
      slidesPerView: 2.5
    },
    1024: {
      slidesPerView: 4
    }
  }
});

const swiperFeaturedProducts = new Swiper(
  '#swiper-featured-products',
  {
    direction: 'horizontal',
    slidesPerView: 1.6,
    spaceBetween: 16,
    slidesOffsetBefore: 16,
    slidesOffsetAfter: 16,
    breakpoints: {
      600: {
        slidesPerView: 3.6
      }
    }
  }
);

// Product carousel
const swiperProductCarouselWrapper = document.querySelector(
  '#swiper-product-carousel'
);

if (swiperProductCarouselWrapper) {
  const swiperProductCarousel = new Swiper('#swiper-product-carousel', {
    direction: 'horizontal',
    slidesPerView: 1.6,
    spaceBetween: 16,
    navigation: {
      nextEl: '.swiper-product-carousel-button-next',
      prevEl: '.swiper-product-carousel-button-prev'
    },
    breakpoints: {
      1024: {
        slidesPerView: 4,
        spaceBetween: 12
      }
    }
  });
}
// End of product carousel

// Testimonials carousel
const swiperTestimonialsWrapper = document.querySelector(
  '#swiper-testimonials'
);

if (swiperTestimonialsWrapper) {
  const swiperTestimonials = new Swiper(
    '#swiper-testimonials',
    {
      direction: 'horizontal',
      slidesPerView: 1.25,
      spaceBetween: 16,
      breakpoints: {
        1024: {
          slidesPerView: 3,
          spaceBetween: 20
        }
      }
    }
  );
}
// End of testimonials carousel

// Gallery carousel
const swiperGalleryWrapper = document.querySelector(
  '#swiper-gallery'
);

if (swiperGalleryWrapper) {
  const swiperGallery = new Swiper('#swiper-gallery', {
    direction: 'horizontal',
    slidesPerView: 1.4,
    spaceBetween: 16,
    slidesOffsetBefore: 16,
    slidesOffsetAfter: 16,
    breakpoints: {
      1024: {
        slidesPerView: 4.2,
        spaceBetween: 20,
        slidesOffsetBefore: 20,
        slidesOffsetAfter: 20
      }
    }
  });
}
// End of gallery carousel

// ================================
// UNIFIED NAVIGATION SYSTEM
// Mobile + Desktop
// ================================

const navigation = document.querySelector('#navigation');
const headerWrapper = document.querySelector('header');
const menuItems = Array.from(
  document.querySelectorAll('#headerMenuItem')
);
const childLinks = document.querySelectorAll(
  '.navigation__child-link'
);
const closeButtons = document.querySelectorAll('.navigation__close');

function closeAllMenus() {
  menuItems.forEach(item => item.classList.remove('active'));
  childLinks.forEach(child => child.classList.remove('active'));
  navigation.classList.remove('active');
  headerWrapper.classList.remove('nav-active');

  document
    .querySelectorAll('.navigation__sub-links.active')
    .forEach(list => {
      list.classList.remove('active');
      list.style.maxHeight = null;
    });
}

menuItems.forEach(item => {
  item.addEventListener('click', e => {
    const navItem = item.dataset.navItem;

    if (!item.classList.contains('has-children')) {
      return;
    }

    e.preventDefault();

    const targetChild = document.querySelector(
      `#navChildMenu[data-nav-item="${navItem}"]`
    );

    const alreadyOpen = item.classList.contains('active');

    closeAllMenus();

    if (!alreadyOpen) {
      item.classList.add('active');
      targetChild.classList.add('active');
      navigation.classList.add('active');
      headerWrapper.classList.add('nav-active');
    }
  });
});

closeButtons.forEach(btn => {
  btn.addEventListener('click', () => closeAllMenus());
});

document.addEventListener('click', e => {
  const clickedInside =
    e.target.closest('#navigation') ||
    e.target.closest('.header__menu');

  if (!clickedInside) closeAllMenus();
});

const columnHeadings = document.querySelectorAll(
  '.navigation__column-heading'
);

columnHeadings.forEach(heading => {
  heading.addEventListener('click', e => {
    const parent = heading.parentElement;
    const subList = parent.querySelector('.navigation__sub-links');

    if (!subList) return;

    e.preventDefault();

    const isOpen = subList.classList.contains('active');

    document
      .querySelectorAll('.navigation__sub-links.active')
      .forEach(list => {
        list.classList.remove('active');
        list.style.maxHeight = null;
      });

    if (!isOpen) {
      subList.classList.add('active');
      subList.style.maxHeight = subList.scrollHeight + 'px';
    }
  });
});
// End of navigation js

// MOBILE VIEWPORT HEIGHT FIX
(() => {
  if (
    CSS.supports('height', '100svh') ||
    CSS.supports('height', '100dvh')
  ) {
    // Browser supports modern units, no need for JS
    return;
  }

  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);

  // Optional: update on resize/orientation change
  window.addEventListener('resize', () => {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  });
})();

/* Toggle Class (Generic) */
function toggleClass(modalName, className = 'active') {
  var modalActive = document.querySelector(modalName);
  modalActive.classList.toggle(className);
}

function toggleMultipleClass(
  selector1,
  selector2,
  className = 'active'
) {
  const el1 = document.querySelector(selector1);
  const el2 = document.querySelector(selector2);

  if (el1) el1.classList.toggle(className);
  if (el2) el2.classList.toggle(className);
}

/* Toggle forgot password form */
const forgotPasswordButtons = document.querySelectorAll(
  '.login__forgot-password-button'
);

forgotPasswordButtons.forEach(button => {
  button.addEventListener('click', function (e) {
    e.preventDefault();
    toggleClass('.login__form');
    toggleClass('.forgot-password-form');

    console.log('here', button);
  });
});

/* Change Product Quantity */
function changeQuantity(formId, quantity) {
  var formQ = document.querySelector(formId);

  if (quantity == '+') {
    Number(formQ.value++);
  } else if (quantity == '-' && formQ.value > 1) {
    Number(formQ.value--);
  }
}

/* Open Cart */
function cartOpen() {
  document.querySelector('body').classList.add('js-my-cart-open');
}

/* Details Animator */
const details = document.querySelectorAll('details');

if (details) {
  details.forEach(targetDetail => {
    targetDetail.addEventListener('click', function (e) {
      if (targetDetail.hasAttribute('open')) {
        e.preventDefault();
        targetDetail.classList.add('closing');
        setTimeout(() => {
          targetDetail.removeAttribute('open');
          targetDetail.classList.remove('closing');
        }, 390);
      }
    });
  });
}

/* Orphan Remove and LSEP Removal */
var nbspSelectors = [
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'p',
  'a',
  'span'
];
var nbspWordMin = 10; //Minimum words within parent tag to activate script

nbspSelectors.forEach(function (selector) {
  var nbspElements = document.querySelectorAll(selector);
  nbspElements.forEach(function (element) {
    element.innerHTML = element.innerHTML.replace(/\u2028/g, '');
    element.innerHTML = element.innerHTML.replace(/&#8232;/g, '');
    var wordCount = element.innerHTML.split(' ').length;
    if (wordCount >= nbspWordMin) {
      element.innerHTML = element.innerHTML.replace(
        / ([^ ]*)$/,
        '&nbsp;$1'
      );
    }
  });
});

/* Lazy Load Initialiser */
var lazyLoadInstance = new LazyLoad({});

/* Liquid Ajax Cart */

liquidAjaxCart.subscribeToCartAjaxRequests(
  (state, subscribeToResult) => {
    if (state.requestType == 'add') {
      const form = state.info.initiator;
      let btnInner = '';

      const btn = form.querySelector('button[type="submit"]');
      if (btn) {
        btnInner = btn.innerHTML;
        btn.innerHTML = 'Adding';
      }

      subscribeToResult(state => {
        const btn = form.querySelector('button[type="submit"]');
        if (state.responseData.ok) {
          cartOpen();
        }

        if (btn) {
          setTimeout(() => {
            btn.innerHTML = btnInner;
          }, 300);
        }
      });
    }
  }
);

/* enterview */
/* Load video on enter */

const llVideos = document.querySelectorAll('video.lazy');

if (llVideos.length > 0) {
  enterView({
    selector: '.video-ll',
    enter: function (el) {
      el.load();
      el.play();
    },
    offset: 0.1
  });
}

// Facets Filters
document.addEventListener('DOMContentLoaded', function () {
  const modal = document.getElementById('FiltersModal');
  const openBtn = document.querySelector('.open-filters');
  const closeBtn = modal.querySelector('.filters-close');
  const overlay = document.querySelector('.filters-overlay');
  const form = document.getElementById('FiltersForm');

  function openModal() {
    modal.classList.add('active');
    document.body.classList.add('no-scroll');
  }
  function closeModal() {
    modal.classList.remove('active');
    document.body.classList.remove('no-scroll');
  }

  openBtn?.addEventListener('click', openModal);
  closeBtn?.addEventListener('click', closeModal);
  overlay?.addEventListener('click', closeModal);

  // Close modal on Apply submit
  form?.addEventListener('submit', function () {
    closeModal();
  });

  // Accordions – allow multiple open
  document
    .querySelectorAll('.js-accordion-toggle')
    .forEach(toggle => {
      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        const group = toggle.closest('.filter-group');
        const options = group.querySelector('.filter-options');

        // Toggle just this accordion
        options.classList.toggle('active');
        toggle.classList.toggle('active');
      });
    });

  // Helper: sync checked -> is-active
  function syncActiveCheckboxes() {
    document
      .querySelectorAll(
        '.filter-options label input[type="checkbox"]'
      )
      .forEach(input => {
        const label = input.closest('label');
        if (!label) return;
        if (input.checked) {
          label.classList.add('is-active');
        } else {
          label.classList.remove('is-active');
        }
      });
  }

  // Initial sync
  syncActiveCheckboxes();

  // Checkbox active state live updates
  document.addEventListener('change', function (e) {
    const input = e.target;
    if (input.type === 'checkbox') {
      const label = input.closest('label');
      if (!label) return;
      if (input.checked) {
        label.classList.add('is-active');
      } else {
        label.classList.remove('is-active');
      }
    }
  });
});

// End of facets filters

// Account nav
function handleAccountPageNav() {
  const pathname = window.location.pathname;
  const hash = window.location.hash;
  const links = document.querySelectorAll('.account-nav-link');

  if (!links.length) return;

  links.forEach(link => link.classList.remove('active'));

  if (pathname === '/account') {
    const sections = document.querySelectorAll('.account-section');

    sections.forEach(section => section.classList.add('hidden'));

    const currentHash = hash || '#dashboard';
    const sectionId = currentHash.replace('#', 'account-');
    const activeSection = document.getElementById(sectionId);
    if (activeSection) {
      activeSection.classList.remove('hidden');
    }

    links.forEach(link => {
      const hrefHash = link.getAttribute('href').split('#')[1];
      if (`#${hrefHash}` === currentHash) {
        link.classList.add('active');
      }
    });

    if (!hash) {
      window.history.replaceState(
        null,
        '',
        `${window.location.pathname}#dashboard`
      );
    }
  }

  if (pathname.includes('/account/addresses')) {
    const addressLink = document.getElementById('addresses-link');
    addressLink?.classList.add('active');
  }
}

document.addEventListener('DOMContentLoaded', handleAccountPageNav);
window.addEventListener('hashchange', handleAccountPageNav);

// UPDATES CART COUNT IN HEADER
document.addEventListener('DOMContentLoaded', () => {
  const countElem = document.querySelector('[data-cart-count]');
  if (!countElem) return;

  function updateCartCount(cart) {
    const count = cart?.item_count || 0;
    countElem.textContent = count;
  }

  // Main Shopify Ajax Cart event (fires on add, remove, quantity change)
  document.addEventListener('ajaxCart:updated', event => {
    updateCartCount(event.detail.cart);
  });

  // Fallback for alternate naming (some builds use this instead)
  document.addEventListener('ajaxCart:cartRequestComplete', event => {
    updateCartCount(event.detail.cart);
  });

  // Safety fallback if neither fires
  document.body.addEventListener('click', e => {
    if (e.target.closest('[data-ajax-cart-request-button]')) {
      setTimeout(() => {
        fetch('/cart.js')
          .then(res => res.json())
          .then(updateCartCount);
      }, 500);
    }
  });

  // Also listen for normal add-to-cart form submissions
  document.body.addEventListener('submit', e => {
    if (e.target.matches('form[action="/cart/add"]')) {
      setTimeout(() => {
        fetch('/cart.js')
          .then(res => res.json())
          .then(updateCartCount);
      }, 800);
    }
  });
});

// Image Hotspots Component
if (!customElements.get('image-hotspots')) {
  class ImageHotspots extends HTMLElement {
    constructor() {
      super();

      this.dots = this.querySelectorAll('.image-hotspots--pin');
      this.activeDot = null;

      this.dots.forEach(dot => {
        this.updateCardPosition(dot);
        dot.addEventListener('click', () => this.handleClick(dot));
      });
    }

    handleClick(dot) {
      const isActive = dot.classList.contains('active');

      // Close all other pins
      this.dots.forEach(d =>
        d.classList.remove('active', 'bottom-dot')
      );
      this.activeDot = isActive ? null : dot;

      if (!isActive) {
        dot.classList.add('active');
        this.updateCardPosition(dot);
        dot.classList.add('hotspot--pinned');
      } else {
        dot.style.setProperty('--content-offset', '0px');
      }
    }

    updateCardPosition(dot) {
      const bubble = dot.querySelector('.image-hotspots--pin-bubble');
      if (!bubble) return;

      const bubbleRect = bubble.getBoundingClientRect();
      const containerRect = this.getBoundingClientRect();

      // Flip vertically if overflowing bottom
      if (bubbleRect.bottom > containerRect.bottom) {
        dot.classList.add('bottom-dot');
      }

      // Adjust horizontally if overflowing left/right
      const offsetLeft = containerRect.left - bubbleRect.left + 30;
      const offsetRight = containerRect.right - bubbleRect.right - 30;

      if (bubbleRect.right > containerRect.right) {
        dot.style.setProperty('--content-offset', `${offsetRight}px`);
      } else if (bubbleRect.left < containerRect.left) {
        dot.style.setProperty('--content-offset', `${offsetLeft}px`);
      } else {
        dot.style.setProperty('--content-offset', '0px');
      }
    }
  }

  customElements.define('image-hotspots', ImageHotspots);
}

// Header homepage Scroll animation
document.addEventListener('DOMContentLoaded', function () {
  const header = document.querySelector('.header');

  if (!header) return;

  const handleScroll = () => {
    if (window.scrollY > 150) {
      header.classList.add('is-scrolled');
    } else {
      header.classList.remove('is-scrolled');
    }
  };

  window.addEventListener('scroll', handleScroll);
  handleScroll();
});

function initProductCards(scope = document) {
  const cards = scope.querySelectorAll('.pcard');
  if (!cards.length) return;

  cards.forEach(card => {
    const productJsonRaw = card.getAttribute('data-product-json');
    if (!productJsonRaw) return;

    let product;
    try {
      product = JSON.parse(productJsonRaw);
    } catch (e) {
      console.warn('Could not parse product JSON', e);
      return;
    }

    if (!product.variants) return;

    const buttons = card.querySelectorAll(
      '.pcard__pair-single-button'
    );
    const form = card.querySelector('.product-card__atc-form');
    const hiddenId = form?.querySelector('input[name="id"]');
    const priceEl = card.querySelector('.pcard__price');

    if (!buttons.length) return;

    function activateVariant(btn) {
      buttons.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');

      const index = parseInt(btn.dataset.optionIndex);
      const value = btn.dataset.optionValue;

      const variant = product.variants.find(
        v => v.options[index] === value
      );

      if (variant) {
        if (hiddenId) hiddenId.value = variant.id;
        const localizedPrice = card.dataset[`price-${variant.id}`];
        if (priceEl && localizedPrice) {
          priceEl.textContent = localizedPrice;
        }
      }
    }

    // Default activation
    activateVariant(buttons[0]);

    buttons.forEach(btn => {
      btn.addEventListener('click', () => activateVariant(btn));
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initProductCards();
});
